import { getCookie, setCookie } from '../utilities/cookies';

const useTheme = (theme = getCookie('theme')) => {
  if (theme == "dark") {
    setCookie('theme', 'light', new Date('2050-01-01').toString())
    document.body.classList.remove('theme--dark').add('theme--light')
  } else {
    setCookie('theme', 'dark', new Date('2050-01-01').toString())
    document.body.classList.add('theme--dark')
  }
}

export { useTheme }
